<template>
  <div :key="id">
    <div class="dot-container">
      <svg :width="w" :height="h" :viewBox="`-20 -20 440 440`" class="dots">
        <defs>
          <radialGradient id="grad" cx="50%" cy="50%" r="50%" fx="80%" fy="80%">
            <stop offset="0%" style="stop-color: #eee; stop-opacity: 0.2;" />
            <stop offset="50%" style="stop-color: #eee; stop-opacity: .2;" />
            <stop offset="100%" style="stop-color:#444; stop-opacity: 0.4;" />
          </radialGradient>
          <radialGradient id="orange" cx="50%" cy="50%" r="50%" fx="80%" fy="80%">
            <stop offset="0%" style="stop-color: rgb(240,148,98); stop-opacity: 1;" />
            <stop offset="50%" style="stop-color:rgb(243,108,33); stop-opacity: 1;" />
            <stop offset="100%" style="stop-color:rgb(173,67,9); stop-opacity: 1;" />
          </radialGradient>
          <radialGradient id="blue" cx="50%" cy="50%" r="50%" fx="80%" fy="80%">
            <stop offset="0%" style="stop-color:#71abd6; stop-opacity: 1;" />
            <stop offset="50%" style="stop-color:#447CBB; stop-opacity: 1;" />
            <stop offset="100%" style="stop-color:#0b5185; stop-opacity: 1;" />
          </radialGradient>
          <radialGradient id="green" cx="50%" cy="50%" r="50%" fx="80%" fy="80%">
            <stop offset="0%" style="stop-color:#8cf0e2; stop-opacity: 1;" />
            <stop offset="50%" style="stop-color:#47BFAF; stop-opacity: 1;" />
            <stop offset="100%" style="stop-color:#118071; stop-opacity: 1;" />
          </radialGradient>
          <radialGradient id="yellow" cx="50%" cy="50%" r="50%" fx="80%" fy="80%">
            <stop offset="0%" style="stop-color:#f0eb8a; stop-opacity: 1;" />
            <stop offset="50%" style="stop-color:#dad344; stop-opacity: 1;" />
            <stop offset="100%" style="stop-color:#9b951c; stop-opacity: 1;" />
          </radialGradient>
        </defs>
        <g id="dots" :class="fill">
          <Dot v-for="dot in dots" :key="dot.id" :id="dot.id" :cx="dot.cx" :cy="dot.cy" :r="r" :fill="fill" :wiggle="wiggle" />
        </g>
      </svg>
    </div>
  </div>
</template>


<script>
import Dot from '../components/Dot'
export default {
  name:"Dots",
  components:{
    Dot
  },
  props:{
    w: {
      type: Number,
      default: 228
    },
    h: {
      type: Number,
      default: 228
    },
    fill:{
      type: String,
      default: 'blue'
    },
    r:{
      type: Number,
      default: 30
    },
    wiggle: {
      type: Number,
      default: 4
    }
  },
  data() {
    return {
      lighterFill: '',
      darkerFill: '',
      dots: [],
      id: Number
    }
  },
  methods: {
    timeToMakeTheDots(){
      let x = this.r;
      let y = this.r;
      let self = this;
      let newDot
      let i = 0
      
      while(y < 400 + this.r){
        newDot = {
          id: i,
          cx: x,
          cy: y
        }

        i++

        self.dots.push(newDot)

        
        if(x + self.r * 2 > 400) {
          y+=self.r*2
          x=self.r
        }else{
          x+=self.r*2
        }

        newDot ={}
      }
    },
    // runwiggle(){
    //   let self = this;
    //   function step() {
    //     self.dots.forEach(d => {
    //       if(Object.prototype.hasOwnProperty.call(d, 'originalX')) {
    //         d.cx = d.originalX;
    //       } else {
    //         d.originalX = d.cx;  
    //       }
    //       if(Object.prototype.hasOwnProperty.call(d, 'originalY')) {
    //         d.cy = d.originalY;
    //       } else {
    //         d.originalY = d.cy;
    //       }
    //       let x= self.wiggle;
    //       let randoX = Math.floor(Math.random() * x) - x*2;
    //       let randoY = Math.floor(Math.random() * x) - x*2;
    //       d.cx += randoX;
    //       d.cy += randoY;
    //     });
    //     window.requestAnimationFrame(step);
    //   }
    //   window.requestAnimationFrame(step);      
    // }
  },
  mounted() {
    // this.runwiggle();
  },
  created() {
    this.id=Math.random()*500
    this.timeToMakeTheDots();
  },
}
</script>


<style lang="scss">
  svg { max-width: 100%; height: auto; }
</style>